var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolusCreditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "#FFDBD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4659 36.1156L27.805 30.7558C31.7531 28.1725 33.193 23.6335 29.6051 18.0511L28.435 16.2305C22.7829 7.59311 12.6655 6.52736 4.00216 12.0513L12.1423 24.7164C13.1364 26.263 15.2952 29.7143 20.3513 26.4646L21.9615 25.4297L22.2215 25.8341L18.3949 28.2936C16.8483 29.2876 16.4006 31.3464 17.3946 32.893L19.4659 36.1156Z",
    fill: "#E5554F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6652 16.0628L42.3261 21.4226C38.3364 23.9412 33.6093 23.3659 30.0213 17.7835L28.8512 15.9629C23.3404 7.23472 26.574 -2.41208 35.1972 -7.99861L43.3374 4.66643C44.3314 6.21303 46.5744 9.61029 41.5183 12.86L39.908 13.8949L40.168 14.2994L43.9946 11.8399C45.5412 10.8459 47.5999 11.2936 48.5939 12.8402L50.6652 16.0628Z",
    fill: "#E5554F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolusCreditIcon);
export default __webpack_public_path__ + "static/media/evolus-credit-icon.b6fb7088478f60e13bc892fb1e93cc95.svg";
export { ForwardRef as ReactComponent };